import React, { useEffect } from "react";
import useIsGtmLoaded from "./useIsGtmLoaded";
import { sendGtmEvent } from "../analytics/definitions";

export type PromotionEvent = {
  id?: string | null;
  name?: string | null;
  position?: string | null;
  isBanner?: boolean | null;
  promotionUrl?: string | null;
};

export const sendPromotionEvent = (
  eventName: string, // Probably want to type this at some point ;)
  promotion: PromotionEvent,
) => {
  sendGtmEvent({
    event: eventName,
    ecommerce: {
      promotion,
    },
  });
};

export function handlePromotionClick(
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
) {
  if (event.currentTarget instanceof HTMLElement) {
    sendPromotionEvent("promotionClick", {
      id: event.currentTarget.dataset.id,
      name: event.currentTarget.dataset.name,
      position: event.currentTarget.dataset.position,
      isBanner: Boolean(event.currentTarget.dataset.isbanner),
      promotionUrl: event.currentTarget.getAttribute("href"),
    });
  }
}
export function createPromotionView(element: Element): PromotionEvent {
  return {
    id: element.getAttribute("data-id"),
    name: element.getAttribute("data-name"),
    position: element.getAttribute("data-position"),
    isBanner: Boolean(element.getAttribute("data-isbanner")),
  };
}

export const usePromotionTracking = (
  containerRef: React.RefObject<HTMLElement>,
) => {
  const [gtmStatus] = useIsGtmLoaded();

  useEffect(() => {
    let gtmPromotions: NodeListOf<Element> | undefined;
    let productAdObserver: IntersectionObserver;

    if (containerRef.current) {
      gtmPromotions = containerRef.current?.querySelectorAll(".gtm-promo");

      if (gtmStatus && gtmPromotions) {
        productAdObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const promotionDetails: PromotionEvent = createPromotionView(
                  entry.target,
                );
                sendPromotionEvent("promotionView", promotionDetails);
                productAdObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.8 },
        );
        gtmPromotions.forEach((node) => {
          if (node) {
            productAdObserver.observe(node);
          }
        });
      }
    }
    function cleanup() {
      productAdObserver?.disconnect();
    }
    return cleanup;
  }, [containerRef, gtmStatus]);
};
